import React, { useEffect, useState } from 'react'
import { ChildrenProps, NativeEvent } from '../../modules/types'
import TextBox from '../atoms/TextBox'
import './FormField.css'

function FormFieldText(props: ChildrenProps) {
  const { title, error, onChange, value, mandatory } = props
  const [text, setText] = useState(value)
  const [hasFocus, setHasFocus] = useState(false)

  useEffect(() => {
    setText(value)
  }, [value])

  function onChangeLocal(e: NativeEvent) {
    if (onChange) {
      setText(e.target.value)
    }
  }

  function onBlur() {
    setHasFocus(false)
    onChange(text)
  }

  return (
    <div>
      <div>
        <b className="form-title">{title}</b>
        {mandatory && (
          <span>*</span>
        )}
      </div>
      
      <TextBox 
        className="form-input" 
        {...props}
        value={text}
        onFocus={() => setHasFocus(true)}
        onChange={onChangeLocal}
        onBlur={onBlur} />

      <div className="form-error">
        {(error && !hasFocus) && (
          <span>{error}</span>
        )}
      </div>
    </div>
  )
}

export default FormFieldText
